import script from "./view-pdf.vue?vue&type=script&setup=true&lang=js"
export * from "./view-pdf.vue?vue&type=script&setup=true&lang=js"

export default script